import type { ComponentProps } from 'react'

import { inputVariants } from './input.styles'

export const InputAddon = (props: ComponentProps<'div'>) => {
  const { addon } = inputVariants()

  return (
    <div
      className={addon()}
      onClick={(e) => {
        if ((e.target as HTMLElement).closest('button')) {
          return
        }
        e.currentTarget.parentElement?.querySelector('input')?.focus()
      }}
      {...props}
    />
  )
}
